export type { MediaPreset } from './src/data/MediaPreset'
export { allMediaPresets } from './src/data/MediaPreset'

import { CenterClient } from './src/gen'

export type { MediaType } from './src/data/MediaType'
export { allMediaTypes } from './src/data/MediaType'
export { Asset } from './src/gen'
export { Collection, SearchResult, ApiError, CenterClient } from './src/gen'

export type { NetworkId } from './src/data/NetworkId'
export {
  CancelablePromise,
  CancelError
} from './src/gen/core/CancelablePromise'

export * from './src/config'

export const client = new CenterClient({
  HEADERS: {
    'X-Center-User-Agent': '@center-inc/api-client'
  }
})
